module.exports = __webpack_public_path__ + "static/img/arcode-wb.92d7f0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/arcode-wb.png
// module id = AURM
// module chunks = 0